import { useTranslation } from 'react-i18next';

import AnalysisRegulationsPL from './locales/pl';

const content = {
  pl: <AnalysisRegulationsPL />,
  en: <AnalysisRegulationsPL />
};

const AnalysisRegulations = () => {
  const { i18n } = useTranslation();
  return content[i18n.language] || <AnalysisRegulationsPL />;
};

export default AnalysisRegulations;
